import React from 'react'
import { QuestionUtils } from '../../../utils/siteUtils'

import Question from './Question'

export default ({ getQuestionResponse, saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment, question, subTextOverride }) => {
  const { questionLabel, questionId } = QuestionUtils.getQuestionLabelAndChoices(question)
  const isSelected = getQuestionResponse(questionId).v

  return (
    <Question
      question={question}
      explanation={question.labelExtended}
      comment={question.acceptsComment}
      selectedIndex={isSelected}
      questionChoices={[questionLabel]}
      questionId={questionId}
      subTextOverride={subTextOverride}
      {...{ saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment }}
    />
  )
}
